import React from "react";
import { Button } from "@/components/ui/button-tw";
import { EyeIcon } from "lucide-react";
import { useCreateInvoiceContext } from "./create-invoice-context";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export const PreviewButton: React.FC = () => {
  const { isPreviewOpen, setIsPreviewOpen } = useCreateInvoiceContext();
  const [isSmallScreen] = useMediaQuery("(max-width: 1559px)");

  if (!isSmallScreen) return null;

  return (
    <Button
      variant="outline"
      onClick={() => setIsPreviewOpen(!isPreviewOpen)}
      className="flex items-center gap-2"
    >
      <EyeIcon className="w-4 h-4" />
      {isPreviewOpen ? (
        <>
          <span className="hidden md:inline">Hide </span>
          <span>Preview</span>
        </>
      ) : (
        <>
          <span className="hidden md:inline">Show </span>
          <span>Preview</span>
        </>
      )}
    </Button>
  );
};
